export const footballSectionsData = [
  {
    title: 'Golovi i tačni rezultati',
    key: 'goalsAndExactScores',
    sections: [
      {
        subtitle: 'Srednji broj golova',
        subKey: 'averageGoals',
        names: ['MIN', 'SRD', 'MAX'],
        withPercent: false,
      },
      {
        subtitle: 'Srednji Tačan Rezulat',
        subKey: 'averageExactScore',
        names: ['MIN', 'SRD', 'MAX'],
        withPercent: false,
      },
      {
        subtitle: 'Srednji Tačan Rezulat - decimalni prikaz',
        subKey: 'averageExactScoreDecimal',
        names: ['MIN', 'SRD', 'MAX'],
        withPercent: false,
      },
    ],
  },
  {
    title: 'Konačan ishod',
    key: 'finalOutcome',
    sections: [
      {
        subtitle: 'Konačan ishod',
        subKey: 'finalOutcome',
        names: [
          'KI 1 ( pobeda domaćina )',
          'KI X ( nerešen rezultat )',
          'KI 2 ( pobeda gosta )',
        ],
      },
      {
        subtitle: 'Dupla šansa',
        subKey: 'doubleChance',
        names: [
          'KI 1X ( pobeda domaćina ili nerešen ishod )',
          'KI 12 ( ili pobeda domaćina ili pobeda gosta )',
          'KI X2 ( nerešen ishod ili pobeda gosta )',
        ],
      },
      {
        subtitle: 'Dupla pobeda',
        subKey: 'doubleWin',
        names: [
          'DP 1 ( pobeda domaćina i u I pol. i u II pol. )',
          'DP 2 ( pobeda gosta i u I pol i u II pol )',
          'SPD 1 ( pobeda domaćina i gost ne daje gol )',
          'SPD 2 ( pobeda gosta i domaćin ne daje gol )',
        ],
      },
      {
        subtitle: 'Poluvreme ili kraj',
        subKey: 'halftimeFulltime',
        names: [
          'PP 1 ILI KI 1 ( pobeda domaćina ili na pol. ili na kraju utak. )',
          'PP X ILI KI X ( nerešen rezultat ili na pol. ili na kraju utak. )',
          'PP 2 ILI KI 2 ( pobeda gosta ili ka pol. ili na kraju utak. )',
        ],
      },
      {
        subtitle: 'Pobeda sa razlikom',
        subKey: 'winByMargin',
        names: [
          'DW 1 ( pobeda domaćina sa 1 golom razlike )',
          'DW 2 ( pobeda domaćina sa 2 gola razlike )',
          'DW 3+ ( pobeda domaćina od 3 i više golova razlike )',
          'GW 1 ( pobeda gosta od 1 gola razlike )',
          'GW 2 ( pobeda gosta od 2 gola razlike )',
          'GW 3+ ( pobeda gosta od 3 i više golova razlike )',
        ],
      },
      {
        subtitle: 'Prvo poluvreme',
        subKey: 'firstHalf',
        names: [
          'PP 1 ( pobeda domaćina u prvom poluvremenu )',
          'PP X ( nerešen rezultat u prvom poluvremenu )',
          'PP 2 ( pobeda gosta u prvom poluvremenu )',
        ],
      },
      {
        subtitle: 'Dupla šansa prvo poluvreme',
        subKey: 'doubleChanceFirstHalf',
        names: [
          'PP 1X ( pobeda domaćina ili nerešeno u prvom pol. )',
          'PP 12 ( pobeda domaćina ili pobeda gosta prvo pol. )',
          'PP X2 ( nerešeno ili pobeda gosta u prvom pol. )',
        ],
      },
      {
        subtitle: 'Super pobeda',
        subKey: 'superWin',
        names: [
          'SP 1 ( pobeda domaćina u oba pol. -gost ne daje gol )',
          'SP 2 ( pobeda gosta u oba pol. -dom. ne daje gol )',
        ],
      },
      {
        subtitle: 'Drugo poluvreme',
        subKey: 'secondHalf',
        names: [
          'DP 1 ( pobeda domaćina u drugom pol )',
          'DP X ( nerešen rezultat u drugom poluvremenu )',
          'DP 2 ( pobeda gosta u drugom poluvremenu )',
        ],
      },
      {
        subtitle: 'Dupla šansa drugo poluvreme',
        subKey: 'doubleChanceSecondHalf',
        names: [
          'DP 1X ( pobeda domaćina ili nerešeno u drugom pol. )',
          'DP 12 ( pobeda domaćina ili pobeda gosta drugo pol. )',
          'DP X2 ( nerešeno ili pobeda gosta u drugom pol. )',
        ],
      },
      {
        subtitle: 'Winner',
        subKey: 'winner',
        names: [
          'W 1 ( dom. tim pobeđuje - u slučaju X-a kv. 1 )',
          'W 2 ( gost. tim pobeđuje - u slučaju X-a kv. 1',
        ],
      },
      {
        subtitle: 'Winner prvo poluvreme',
        subKey: 'winnerFirstHalf',
        names: [
          'WP 1 ( dom. tim pobeđuje u I pol. - u slučaju X-a kv. 1 )',
          'WP 2 ( gost. tim pobeđuje u I pol. - u slučaju X-a kv. 1',
        ],
      },
      {
        subtitle: 'Winner drugo poluvreme',
        subKey: 'winnerSecondHalf',
        names: [
          'WDP 1 ( dom. tim pobeđuje u II pol. - u slučaju X-a kv. 1 )',
          'WDP 2 ( gost. tim pobeđuje u II pol. - u slučaju X-a kv. 1',
        ],
      },
    ],
  },
  {
    title: 'Ukupno golova',
    key: 'totalGoals',
    sections: [
      {
        subtitle: 'Raspon od 1 gola',
        subKey: 'goalRangeOf1',
        names: [
          'UG 0-1 ( na utakmici će biti od 0 do 1 gola )',
          'UG 1-2 ( na utakmici će biti od 1 do 2 gola )',
          'UG 2-3 ( na utakmici će biti od 2 do 3 gola )',
          'UG 3-4 ( na utakmici će biti od 3 do 4 gola ',
          'UG 4-5 ( na utakmici će biti od 4 do 5 golova )',
          'UG 5-6 ( na utakmici će biti od 5 do 6 golova )',
        ],
      },
      {
        subtitle: 'Raspon od 2 gola',
        subKey: 'goalRangeOf2',
        names: [
          'UG 0-2 ( na utakmici će biti od 0 do 2 gola )',
          'UG 1-3 ( na utakmici će biti od 1 do 3 gola )',
          'UG 2-4 ( na utakmici će biti od 2 do 4 gola )',
          'UG 3-5 ( na utakmici će biti od 3 do 5 golova ',
          'UG 4-6 ( na utakmici će biti od 4 do 6 golova )',
        ],
      },
      {
        subtitle: 'Raspon od 3 gola',
        subKey: 'goalRangeOf3',
        names: [
          'UG 0-3 ( na utakmici će biti od 0 do 3 gola )',
          'UG 1-4 ( na utakmici će biti od 1 do 4 gola )',
          'UG 2-5 ( na utakmici će biti od 2 do 5 golova )',
          'UG 3-6 ( na utakmici će biti od 3 do 6 golova )',
        ],
      },
      {
        subtitle: 'Raspon od 4 gola',
        subKey: 'goalRangeOf4',
        names: [
          'UG 0-4 ( na utakmici će biti od 0 do 4 gola )',
          'UG 1-5 ( na utakmici će biti od 1 do 5 golova )',
          'UG 2-6 ( na utakmici će biti od 2 do 6 golova )',
        ],
      },
      {
        subtitle: 'Gol plus',
        subKey: 'goalPlus',
        names: [
          'UG 2+ ( na utakmici će biti 2 ili više golova )',
          'UG 3+ ( na utakmici će biti 3 ili više golova )',
          'UG 4+ ( na utakmici će biti 4 ili više golova )',
          'UG 5+ ( na utakmici će biti 5 ili više golova )',
          'UG 6+ ( na utakmici će biti 6 ili više golova )',
          'UG 7+ ( na utakmici će biti 7 ili više golova )',
        ],
      },
      {
        subtitle: 'Tačan broj golova',
        subKey: 'exactScore',
        names: [
          'T 0 ( na utakmici će biti tačno 0 golova )',
          'T 1 ( na utakmici će biti tačno 1 gol )',
          'T 2 ( na utakmici će biti tačno 2 gola )',
          'T 3 ( na utakmici će biti tačno 3 gola )',
          'T 4 ( na utakmici će biti tačno 4 gola )',
          'T 5 ( na utakmici će biti tačno 5 golova )',
          'T 6 ( na utakmici će biti tačno 6 golova )',
        ],
      },
      {
        subtitle: 'Oba tima daju gol',
        subKey: 'bothTeamsScore',
        names: [
          'GG ( oba tima daju gol na utakmici )',
          'NEGG ( najmanje jedan tim ne daje gol na utakmici )',
          'GG 1 ( oba tima daju gol u I poluvremenu )',
          'NEGG 1 ( najmanje jedan tim ne daje gol u I pol. )',
          'GG 2 ( oba tima daju gol u II poluvremenu )',
          'NEGG 2 ( najmanje jedan tim ne daje gol u II pol.',
        ],
      },
      {
        subtitle: 'Prvi daje gol',
        subKey: 'firstGoal',
        names: [
          'PG 1 ( prvi gol na utakmici daje domaćin )',
          'PG X ( neće biti golova na utakmici )',
          'PG 2 ( prvi gol na utakmici daje gost )',
          'PP PG ( prvi gol na utakmici pada u I poluvremenu )',
          'DP PG ( prvi gol na utakmici pada u II poluvremenu )',
          'PP PGD (  prvi gol na utakmici daje  domaćin u I pol. )',
          'PP PGG ( prvi gol na utakmici daje gost u I poluvremenu )',
          'DP PGD ( prvi gol na utakmici daje domaćin  u II pol. )',
          'DP PGG ( prvi gol na utakmici daje gost II poluvremenu )',
        ],
      },
      {
        subtitle: 'Zadnji daje gol',
        subKey: 'lastGoal',
        names: [
          'ZG 1 ( zadnji gol na utakmici daje domaćin )',
          'ZG 2 ( zadnji gol na utakmici daje gost )',
        ],
      },
      {
        subtitle: 'Ukupno golova I poluvreme',
        subKey: 'totalGoalsFirstHalf',
        names: [
          'PP 1+ ( u I poluvremenu će biti 1 ili više golova )',
          'PP 2+ ( u I poluvremenu će biti 2 ili više golova )',
          'PP 3+ ( u I poluvremenu će biti 3 ili više golova )',
          'PP 4+ ( u I poluvremenu će biti 4 ili više golova ',
          'PP 0-1 ( u I poluvremenu će biti od 0 do 1 gola )',
          'PP 0-2 ( u I poluvremenu će biti od 0 do 2 gola )',
          'PP 1-2 ( u I poluvremenu će biti od 1 do 2 gola )',
          'PP 1-3 ( u I poluvremenu će biti od 1 do 3 gola )',
          'PP 2-3 ( u I poluvremenu će biti od 2 do 3 gola )',
          'PT 0 ( u I poluvremenu će biti tačno 0 golova )',
          'PT 1 ( u I poluvremenu će biti tačno 1 gol )',
          'PT 2 ( u I poluvremenu će biti tačno 2 gola )',
          'PT 3 ( u I poluvremenu će biti tačno 3 gola )',
          'PP NEG 1 ( u I poluvremenu neće biti tačno 1 gol )',
          'PP NEG 2 ( u I poluvremenu neće biti tačno 2 gola )',
          'PPGX ( u I poluvremenu će biti tačno 0 golova )',
        ],
      },
      {
        subtitle: 'Ukupno golova II poluvreme',
        subKey: 'totalGoalsSecondHalf',
        names: [
          'DP 1+ ( u II poluvremenu će biti 1 ili više golova )',
          'DP 2+ ( u II poluvremenu će biti 2 ili više golova )',
          'DP 3+ ( u II poluvremenu će biti 3 ili više golova )',
          'DP 4+ ( u II poluvremenu će biti 4 ili više golova ',
          'DP 0-1 ( u II poluvremenu će biti od 0 do 1 gola )',
          'DP 0-2 ( u II poluvremenu će biti od 0 do 2 gola )',
          'DP 1-2 ( u II poluvremenu će biti od 1 do 2 gola )',
          'DP 1-3 ( u II poluvremenu će biti od 1 do 3 gola )',
          'DP 2-3 ( u II poluvremenu će biti od 2 do 3 gola )',
          'DPT 0 ( u II poluvremenu će biti tačno 0 golova )',
          'DPT 1 ( u II poluvremenu će biti tačno 1 gol )',
          'DPT 2 ( u II poluvremenu će biti tačno 2 gola )',
          'DPT 3 ( u II poluvremenu će biti tačno 3 gola )',
          'DP NEG 1 ( u II poluvremenu neće biti tačno 1 gol )',
          'DP NEG 2 ( u II poluvremenu neće biti tačno 2 gola )',
          'DPGX ( u II poluvremenu će biti tačno 0 golova )',
        ],
      },
      {
        subtitle: 'Raspon od 1 gola',
        subKey: 'goalSpreadOf1',
        names: [
          '1P1+ & 2+ ( I pol. 1 i više golova & uk.golova na ut. 2 i više )',
          '1P1+ & 3+ ( I pol. 1 i više golova & uk.golova na ut. 3 i više )',
          '1P1+ & 2P1+ ( I pol. 1 i više golova & II pol. 1 i više golova )',
          '1P1+ & 2P2+ ( I pol. 1 i više golova & II pol. 2 i više golova )',
          '1P1+ & 2P3+ ( I pol. 1 i više golova & II pol. 3 i više golova )',
          '1P1+ & 2P0-1 ( I pol. 1 i više golova & II pol. od 0 do 1 gol )',
          '1P1+ & 2P0-2 ( I pol. 1 i više golova & II pol. od 0 do 2 gola )',
          '1P1+ & 2P1-2 ( I pol. 1 i više golova & II pol. od 1 do 2 gola )',
          '1P1+ & 2P1-3 ( I pol. 1 i više golova & II pol. od 1 do 3 gola )',
          '1P1+ & 2P2-3 ( I pol. 1 i više golova & II pol. od 2 do 3 gola )',
          '1P0-1 & 2P2+ ( I pol. od 0 do 1 gol & II pol. 2 ili više golova )',
          '1P0-1 & 2P0-1 ( I pol. od 0 do 1 gol & II pol. od 0 do 1 gol )',
          '1P0-1 & 2P0-3 ( I pol. od 0 do 1 gol & II pol. od 0 do 3 gola )',
          '1P0-1 & 2P1-2 ( I pol. od 0 do 1 gol & II pol. od 1 do 2 gol )',
          '1P0-1 & 2P1-3 ( I pol. od 0 do 1 gol & II pol. od 1 do 3 gola )',
          '1P0-1 & 2P2-3 ( I pol. od 0 do 1 gol & II pol. od 2 do 3 gol )',
          '1P2+ & 2P1+ ( I pol. 2 i više golova & II pol. 1 i više golova )',
          '1P2+ & 2P2+ ( I pol. 2 i više golova & II pol. 2 i više golova )',
          '1P2+ & 2P3+ ( I pol. 2 i više golova & II pol. 3 i više golova )',
          '1P2+ & 2P4+ ( I pol. 2 i više golova & II pol. 4 i više golova )',
          '1P2+ & 2P0-1 ( I pol. 2 i više golova & II pol. od 0 do 1 gola )',
          '1P2+ & 2P2-3 ( I pol. 2 i više golova & II pol. od 2 do 3 gola )',
          '1P0-2 & 2P2+ ( I pol. od 0 do 2 gola & II pol. 2 i više golova )',
          '1P0-2 & 2P0-1 ( I pol. od 0 do 2 gola & II pol. od 0 do 1 gol )',
          '1P0-2 & 2P0-2 ( I pol. od 0 do 2 gola & II pol. od 0 do 2 gola )',
          '1P0-2 & 2P0-3 ( I pol. od 0 do 2 gola & II pol. od 0 do 3 gola )',
          '1P0-2 & 2P1-2 ( I pol. od 0 do 2 gola & II pol. od 1 do 2 gola )',
          '1P0-2 & 2P1-3 ( I pol. od 0 do 2 gola & II pol. od 1 do 3 gola )',
          '1P0-2 & 2P2-3 ( I pol. od 0 do 2 gola & II pol. od 2 do 3 gola )',
          '1P1-2 & 2P1+ ( I pol. od 1 do 2 gola & II pol. 1 i više golova )',
          '1P1-2 & 2P2+ ( I pol. od 1 do 2 gola & II pol. 2 i više golova )',
          '1P1-2 & 2P0-1 ( I pol. od 1 do 2 gola & II pol. od 0 do 1 gol )',
          '1P1-2 & 2P0-2 ( I pol. od 1 do 2 gola & II pol. od 0 do 2 gola )',
          '1P1-2 & 2P0-3 ( I pol. od 1 do 2 gola & II pol. od 0 do 3 gola )',
          '1P1-2 & 2P3+ ( I pol. od 1 do 2 gola & II pol. 3 i više golova )',
          '1P1-2 & 2P4+ ( I pol. od 1 do 2 gola & II pol. 4 i više golova )',
          '1P1-3 & 2P3+ ( I pol. od 1 do 3 gola & II pol. 3 i više golova )',
          '1P1-3 & 2P1+ ( I pol. od 1 do 3 gola & II pol. 1 i više golova )',
          '1P1-3 & 2P2+ ( I pol. od 1 do 3 gola & II pol. 2 i više golova )',
          '1P1-3 & 2P1-2 ( I pol. od 1 do 3 gola & II pol. od 1 do 2 gola )',
          '1P1-3 & 2P1-3 ( I pol. od 1 do 3 gola & II pol. od 1 do 3 gola )',
          '1P2-3 & 2P1+ ( I pol. od 2 do 3 gola & II pol. 1 i više golova )',
          '1P2-3 & 2P2+ ( I pol. od 2 do 3 gola & II pol. 2 i više golova )',
          '1P2-3 & 2P3+ ( I pol. od 2 do 3 gola & II pol. 3 i više golova )',
          '1P2-3 & 2P4+ ( I pol. od 2 do 3 gola & II pol. 4 i više golova )',
          '1P2-3 & 2P0-1 ( I pol. od 2 do 3 gola & II pol. 3 od 0 do 1 gol )',
          '1P2-3 & 2P0-2 ( I pol. od 2 do 3 gola & II pol. od 0 do 2 gola )',
          '1P2-3 & 2P1-3 ( I pol. od 2 do 3 gola & II pol. od 1 do 3 gola )',
          '1P2-3 & 2P1-2 ( I pol. od 2 do 3 gola & II pol. od 1 do 2 gola )',
          '1P2-3 & 2P2-3 ( I pol. od 2 do 3 gola & II pol. od 2 do 3 gola )',
          '1P2+&4+ ( I pol. 2 i više golova & ukupno 4 i više golova )',
          '2P2+&4+ ( II pol. 2 i više golova & ukupno 4 i više golova )',
        ],
      },
      {
        subtitle: 'Domaćin golovi',
        subKey: 'homeGoals',
        names: [
          'D1+ ( domaćin daje 1 ili više golova na utakmici )',
          'D2+ ( domaćin daje 2 ili više golova na utakmici )',
          'D3+ ( domaćin daje 3 ili više golova na utakmici )',
          'D4+ ( domaćin daje 4 ili više golova na utakmici )',
          'D 0-1 ( domaćin daje od 0 do 1 gol na utakmici )',
          'D 0-2 ( domaćin daje od 0 do 2 gola na utakmici )',
          'D 0-3 ( domaćin daje od 0 do 3 gola na utakmici )',
          'D 0 ( domaćin ne daje gola na utakmici )',
          'DT 1 ( domaćin daje tačno 1 gol na utakmici )',
          'DT 2 ( domaćin daje tačno 2 gola na utakmici )',
          'DT 3 ( domaćin daje tačno 3 gola na utakmici )',
          'D 1-2 ( domaćin daje od 1 do 2 gola na utakmici )',
          'D 1-3 ( domaćin daje od 1 do 3 gola na utakmici )',
          'D 2-3 ( domaćin daje od 2 do 3 gola na utakmici )',
          'D 2-4 ( domaćin daje od 2 do 4 gola na utakmici )',
          'D 2-5 ( domaćin daje od 2 do 5 golova na utakmici )',
          'D 2-6 ( domaćin daje od 2 do 6 golova na utakmici )',
          'D 3-4 ( domaćin daje od 3 do 4 gola na utakmici )',
          'D 3-5 ( domaćin daje od 3 do 5 golova na utakmici )',
          'D 4-6 ( domaćin daje od 4 do 6 golova na utakmici )',
          'DT 4 ( domaćin daje tačno 4 gola na utakmici )',
          'DT 5 ( domaćin daje tačno 5 golova na utakmici )',
          'DT 6 ( domaćin daje tačno 6 golova na utakmici )',
          'D UG 7+ ( domaćin daje 7 ili više golova na utakmici )',
        ],
      },
      {
        subtitle: 'Domaćin golovi prvo poluvreme',
        subKey: 'homeGoalsFirstHalf',
        names: [
          '1D1+ ( domaćin daje 1 ili više golova u I pol. )',
          '1D2+ ( domaćin daje 2 ili više golova u I pol. )',
          '1D3+ ( domaćin daje 3 ili više golova u I pol. )',
          '1D4+ ( domaćin daje  4 ili više golova u I pol. )',
          '1D 0 ( domaćin ne daje gol u I pol. )',
          '1DT 1 ( domaćin daje tačno 1 gol u I pol. )',
          '1DT 2 ( domaćin daje tačno 2 gola u I pol. )',
          '1D 0-1 ( domaćin daje od 0 do 1 gol u I pol. )',
          '1D 1-2 ( domaćin daje od 1 do 2 gola u I pol. )',
          '1D 2-3 ( domaćin daje od 2 do 3 gola u I pol. )',
          '1PPG1 ( domaćin daje prvi gol u I pol. )',
          '1DT 3 ( domaćin daje tačno 3 gola u I pol. )',
        ],
      },
      {
        subtitle: 'Domaćin golovi drugo poluvreme',
        subKey: 'homeGoalsSecondHalf',
        names: [
          '2D1+ ( domaćin daje 1 ili više golova u II pol. )',
          '2D2+ ( domaćin daje 2 ili više golova u II pol. )',
          '2D3+ ( domaćin daje 3 ili više golova u II pol. )',
          '2D4+ ( domaćin daje  4 ili više golova u II pol. )',
          '2D 0 ( domaćin ne daje gol u II pol. )',
          '2DT 1 ( domaćin daje tačno 1 gol u II pol. )',
          '2DT 2 ( domaćin daje tačno 2 gola u II pol. )',
          '2D 0-1 ( domaćin daje od 0 do 1 gol u II pol. )',
          '2D 1-2 ( domaćin daje od 1 do 2 gola u II pol. )',
          '2D 2-3 ( domaćin daje od 2 do 3 gola u II pol. )',
          '2PPG1 ( domaćin daje prvi gol u II pol. )',
          '2DT 3 ( domaćin daje tačno 3 gola u II pol. )',
        ],
      },
      {
        subtitle: 'Domaćin golovi - miks golova',
        subKey: 'homeGoalsHomeMix',
        names: [
          '1D1+ & D2+ ( domaćin daje 1 ili više golova u I pol. i 2 ili više uk. )',
          '1D1+ & D3+ ( domaćin daje 1 ili više golova u I pol. i 3 ili više uk. )',
          '1D1+ & 2D2+ ( domaćin daje 1 ili više golova u I pol. i 2 ili više u II )',
          '1D2+ & 2D1+ ( domaćin daje 2 ili više golova u I pol. i 1 ili više u II )',
          '1D2+ & 2D2+ ( domaćin daje 2 ili više golova u I pol. i 2 ili više u II )',
          '1D0-1 & 2D0-1 ( domaćin daje od 0 do 1 gol u I pol. i od 0 do 1 u II )',
          '1D0-1 & 2D0-2 ( domaćin daje od 0 do 1 gol u I pol. i od 0 do 2 u II )',
          '1D0-2 & 2D0-1 ( domaćin daje od 0 do 2 gola u I pol. i od 0 do 1 u II )',
          '1D0-2 & 2D0-2 ( domaćin daje od 0 do 2 gola u I pol. i od 0 do 2 u II )',
          '1D1 & 4+ ( domaćin daje tačno 1 gol u I pol. i 4 ili više uk. )',
        ],
      },
      {
        subtitle: 'Gost golovi',
        subKey: 'guestGoals',
        names: [
          'G1+ ( gost daje 1 ili više golova na utakmici )',
          'G2+ ( gost daje 2 ili više golova na utakmici )',
          'G3+ ( gost daje 3 ili više golova na utakmici )',
          'G4+ ( gost daje 4 ili više golova na utakmici )',
          'G 0-1 ( gost daje od 0 do 1 gol na utakmici )',
          'G 0-2 ( gost daje od 0 do 2 gola na utakmici )',
          'G 0-3 ( gost daje od 0 do 3 gola na utakmici )',
          'G 0 ( gost ne daje gola na utakmici )',
          'GT 1 ( gost daje tačno 1 gol na utakmici )',
          'GT 2 ( gost daje tačno 2 gola na utakmici )',
          'GT 3 ( gost daje tačno 3 gola na utakmici )',
          'G 1-2 ( gost daje od 1 do 2 gola na utakmici )',
          'G 1-3 ( gost daje od 1 do 3 gola na utakmici )',
          'G 2-3 ( gost daje od 2 do 3 gola na utakmici )',
          'G 2-4 ( gost daje od 2 do 4 gola na utakmici )',
          'G 2-5 ( gost daje od 2 do 5 golova na utakmici )',
          'G 2-6 ( gost daje od 2 do 6 golova na utakmici )',
          'G 3-4 ( gost daje od 3 do 4 gola na utakmici )',
          'G 3-5 ( gost daje od 3 do 5 golova na utakmici )',
          'G 4-6 ( gost daje od 4 do 6 golova na utakmici )',
          'GT 4 ( gost daje tačno 4 gola na utakmici )',
          'GT 5 ( gost daje tačno 5 golova na utakmici )',
          'GT 6 ( gost daje tačno 6 golova na utakmici )',
          'G UG 7+ ( gost daje 7 ili više golova na utakmici )',
        ],
      },
      {
        subtitle: 'Gost golovi prvo poluvreme',
        subKey: 'guestGoalsFirstHalf',
        names: [
          '1G1+ ( gost daje 1 ili više golova u I pol. )',
          '1G2+ ( gost daje 2 ili više golova u I pol. )',
          '1G3+ ( gost daje 3 ili više golova u I pol. )',
          '1G4+ ( gost daje 4 ili više golova u I pol. )',
          '1G 0 ( gost ne daje gol u I pol. )',
          '1GT 1 ( gost daje tačno 1 gol u I pol. )',
          '1GT 2 ( gost daje tačno 2 gola u I pol. )',
          '1G 0-1 ( gost daje od 0 do 1 gol u I pol. )',
          '1G 1-2 ( gost daje od 1 do 2 gola u I pol. )',
          '1G 2-3 ( gost daje od 2 do 3 gola u I pol. )',
          '1PPG 2 ( gost daje prvi gol u I pol. )',
          '1GT 3 ( gost daje tačno 3 gola u I pol. )',
        ],
      },
      {
        subtitle: 'Gost golovi drugo poluvreme',
        subKey: 'guestGoalsSecondHalf',
        names: [
          '2G1+ ( gost daje 1 ili više golova u II pol. )',
          '2G2+ ( gost daje 2 ili više golova u II pol. )',
          '2G3+ ( gost daje 3 ili više golova u II pol. )',
          '2G4+ ( gost daje 4 ili više golova u II pol. )',
          '2G 0 ( gost ne daje gol u II pol. )',
          '2GT 1 ( gost daje tačno 1 gol u II pol. )',
          '2GT 2 ( gost daje tačno 2 gola u II pol. )',
          '2G 0-1 ( gost daje od 0 do 1 gol u II pol. )',
          '2G 1-2 ( gost daje od 1 do 2 gola u II pol. )',
          '2G 2-3 ( gost daje od 2 do 3 gola u II pol. )',
          '2PPG 2 ( gost daje prvi gol u II pol. )',
          '2GT 3 ( gost daje tačno 3 gola u II pol. )',
        ],
      },
      {
        subtitle: 'Gost golovi - miks golova',
        subKey: 'homeGoalsMix',
        names: [
          '1G1+ & G2+ ( gost daje 1 ili više golova u I pol. i 2 ili više uk. )',
          '1G1+ & G3+ ( gost daje 1 ili više golova u I pol. i 3 ili više uk. )',
          '1G1+ & 2G2+ ( gost daje 1 ili više golova u I pol. i 2 ili više u II )',
          '1G2+ & 2G1+ ( gost daje 1 ili više golova u I pol. i 1 ili više u II )',
          '1G2+ & 2G2+ ( gost daje 2 ili više golova u I pol. i 2 ili više u II )',
          '1G0-1 & 2G0-1 ( gost daje od 0 do 1 gol u I pol. i od 0 do 1 u II )',
          '1G0-1 & 2G0-2 ( gost daje od 0 do 1 gol u I pol. i od 0 do 2 u II )',
          '1G0-2 & 2G0-1 ( gost daje od 0 do 2 gola u I pol. i od 0 do 1 u II )',
          '1G0-2 & 2G0-2 ( gost daje od 0 do 2 gola u I pol. i od 0 do 2 u II )',
          '1G1 & 2G4+ ( gost daje tačno 1 gol u I pol. i 4 ili više u II )',
        ],
      },
      {
        subtitle: 'Miks - GG',
        subKey: 'mixGG',
        names: [
          'GG3+ ( oba tima daju  gol i na ut. će biti min. 3 gola )',
          'GG4+ ( oba tima daju  gol i na ut. će biti min. 4 gola )',
          'D2+ & G2+ ( oba tima daju  min. po 2 gola na utakmici )',
          'GG & D2+ ( oba tima daju gol i dom. daje min. 2 gola na ut. )',
          'GG & G2+ ( oba tima daju gol i gost  daje min. 2 gola na ut. )',
          'GG & 2-3 ( oba tima daju  gol i od 2 do 3 gola na utakmici )',
          'NEGG3+ ( min. 1 tim ne daje gol i min. 3 gola na utakmici )',
        ],
      },
      {
        subtitle: 'Daje ne daje gol Ip i IIp domaćin',
        subKey: 'scoreOrNoScoreHome',
        names: ['DGD ( domaćin daje gol )', 'NGD ( domaćin ne daje gol )'],
      },
      {
        subtitle: 'Daje ne daje gol Ip i IIp gost',
        subKey: 'scoreOrNoScoreAway',
        names: ['DGG ( gost daje gol )', 'NGG ( gost ne daje gol )'],
      },
      {
        subtitle: 'Pada više golova',
        subKey: 'moreGoalsIn',
        names: [
          '1 > ( pada više golova u I pol. utakmice )',
          '1 = 2 ( pada jednak broj golova u I i u II pol. utakmice )',
          '2 > ( pada više golova u II pol. utakmice)',
        ],
      },
    ],
  },
  {
    title: 'Poluvreme - kraj',
    key: 'halftimeEnd',
    sections: [
      {
        subtitle: 'Poluvreme - kraj',
        subKey: 'halftimeEnd',
        names: [
          'PK 1-1 ( dom. vodi posle I pol. i pobeđuje na kraju ut. )',
          'PK 1-X ( dom. vodi posle I pol. i nerešeno na kraju ut. )',
          'PK 1-2 ( dom. vodi posle I pol. i gubi na kraju ut. )',
          'PK X-1 ( nerešeno posle I pol. i pobeda dom. na kraju )',
          'PK X-X ( nerešeno posle I pol. i nerešeno. na kraju )',
          'PK X-2 ( nerešeno posle I pol. i pobeda gosta na kraju )',
          'PK 2-1 ( gost vodi posle I pol. i gubi na kraju ut. )',
          'PK 2-X ( gost. vodi posle I pol. i nerešeno na kraju ut. )',
          'PK 2-2 ( gost vodi posle I pol. i pobeđuje na kraju ut. )',
          'NE 1-1 ( dom. ne vodi posle I pol. i ne pobeđuje ut. )',
          'NE 2-2 ( gost ne vodi posle I pol. i ne pobeđuje na ut. )',
          'PK X-1 ( ne nerešeno posle I pol. i ne pobeda dom. )',
          'PK X-X ( ne nerešeno posle I pol. i ne nerešeno. na kraju )',
          'PK X-2 ( ne nerešeno posle I pol. i ne pobeda gosta )',
          'NE 1-2 ( dom. ne vodi posle I pol. i gost ne pobeđuje )',
          'NE 1-X ( dom. ne vodi posle I pol. i ne nerešeno na ut. )',
          'NE 2-1 ( gost ne vodi posle I pol. i dom. ne pobeđuje )',
          'NE 2-X ( gost ne vodi posle I pol. i ne nerešeno na kraju )',
        ],
      },
      {
        subtitle: 'Poluvreme - kraj dupla šansa',
        subKey: 'halftimeEndDoubleChance',
        names: [
          'PK 1-1X ( dom. vodi posle I pol. i ne gubi na kraju ut. )',
          'PK 1-X2 ( dom. vodi posle I pol. i ne pobeđuje na kraju )',
          'PK 1-12 ( dom. vodi posle I pol. i ne nerešeno na kraju )',
          'PK 2-1X ( gost vodi posle I pol. i ne pobeđuje na kraju )',
          'PK 2-X2 ( gost vodi posle I pol. i ne gubi na kraju ut. )',
          'PK 2-12 ( gost vodi posle I pol. i ne nerešeno na kraju )',
          'PK X-1X ( nerešeno posle I pol. i dom. ne gubi na kraju )',
          'PK X-X2 ( nerešeno posle I pol. i gost ne gubi na kraju )',
          'PK X-12 ( nerešeno posle I pol. i ne nerešeno na kraju )',
          'PK 1X-1 ( dom. ne gubi posle I pol. i pobeđuje na kraju )',
          'PK 1X-X ( dom. ne gubi posle I pol. i nerešeno na kraju )',
          'PK 1X-2 ( dom. ne gubi posle I pol. i gubi na kraju )',
          'PK X2-1 ( gost ne gubi posle I pol. i gubi na kraju )',
          'PK X2-X ( gost ne gubi posle I pol. i nerešeno na kraju )',
          'PK X2-2 ( gost ne gubi posle I pol. i pobeđuje na kraju )',
          'PK 12-1 ( ne nerešeno posle I pol. i dom. pobeđuje )',
          'PK 12-X ( ne nerešeno posle I pol. i nerešeno na kraju )',
          'PK 12-2 ( ne nerešeno posle I pol. i gost pobeđuje )',
          'PK 1X-1X ( gost gubi posle I pol. i ne pobeđuje na kraju )',
          'PK 1X-X2 ( gost gubi posle I pol. i ne gubi na kraju )',
          'PK 1X-12 ( gost gubi posle I pol. i ne nerešeno na kraju )',
          'PK X2-1X ( dom. gubi posle I pol. i ne gubi na kraju )',
          'PK X2-X2 ( dom. gubi posle I pol. i ne pobeđuje na kraju )',
          'PK X2-12 ( dom. gubi posle I pol. i ne nerešeno na kraju )',
          'PK 12-1X ( ne nerešeno posle I pol. i dom. ne gubi na kraju )',
          'PK 12-X2 ( ne nerešeno posle I pol. i gost ne gubi na kraju )',
          'PK 12-12 ( ne nerešeno posle I pol. i ne nerešeno na kraju )',
        ],
      },
    ],
  },
  {
    title: 'Hendikepi',
    key: 'handicaps',
    sections: [
      {
        subtitle: 'Hendikep (-1)',
        subKey: 'handicapMinus1',
        names: [
          'H 1 ( dom. ne gubi sa 2 ili više golova razlike )',
          'H X ( dom. ne gubi sa 1 ili više golova razlike )',
          'H 2 ( dom. ne gubi ili je nerešen rezultat )',
        ],
      },
      {
        subtitle: 'Hendikep (-2)',
        subKey: 'handicapMinus2',
        names: [
          'H 1 ( dom. ne gubi sa 3 ili više golova razlike )',
          'H X ( dom. ne gubi sa 2 ili više golova razlike )',
          'H 2 ( dom. ne gubi sa 1 ili više golova razlike )',
        ],
      },
    ],
  },
  {
    title: 'Miks igre',
    key: 'mixGames',
    sections: [
      {
        subtitle: 'Konačan ishod - golovi',
        subKey: 'finalOutcomeGoals',
        names: [
          '1 & D2+ ( dom. pobeđuje i daje min. 2 gola na utakmici )',
          '1 & D3+ ( dom. pobeđuje i daje min. 3 gola na utakmici )',
          '1 & 3+ ( dom. pobeđuje i  min. 4 gola na utakmici )',
          '1 & 4+ ( dom. pobeđuje i min. 4 gola na utakmici )',
          '1 & 5+ ( dom. pobeđuje i  min. 5 golova na utakmici )',
          '1 & 1P1+ ( dom. pobeđuje i min. 1 gol u I pol. )',
          '1 & 1P2+ ( dom. pobeđuje i  min. 2 gola u I pol. )',
          '1 & 2P1+ ( dom. pobeđuje i min. 1 gol u II pol. )',
          '1 & 2P2+ ( dom. pobeđuje i  min. 2 gola u II pol. )',
          '1&1P1+ & 2P1+ ( dom. pobeđuje i min. 1 gol i u I pol. i u II pol. )',
          '1 & 0-2 ( dom. pobeđuje i na ut. će biti od 0 do 2 gola )',
          '1 & 0-3 ( dom. pobeđuje i na ut. će biti od 0 do 3 gola )',
          '1 & 0-4 ( dom. pobeđuje i na ut. će biti od 0 do 4 gola )',
          '1 & 2-3 ( dom. pobeđuje i na ut. će biti od 2 do 3 gola )',
          '1 & 2-4 ( dom. pobeđuje i na ut. će biti od 2 do 4 gola )',
          '1 & 2-5 ( dom. pobeđuje i na ut. će biti od 2 do 5 golova )',
          '1 & 2-6 ( dom. pobeđuje i na ut. će biti od 2 do 6 golova )',
          '1 & 3-4 ( dom. pobeđuje i na ut. će biti od 3 do 4 gola )',
          '1 & 3-5 ( dom. pobeđuje i na ut. će biti od 3 do 5 golova )',
          '1 & 3-6 ( dom. pobeđuje i na ut. će biti od 3 do 6 golova )',
          '1 & 1P2-3 ( dom. pobeđuje i u I pol. pada od 2 do 3 gola )',
          '2 & G2+ ( gost pobeđuje i daje min. 2 gola na ut. )',
          '2 & G3+ ( gost pobeđuje i daje min. 3 gola na ut. )',
          '2 & 3+ ( gost pobeđuje i min. 2 gola na ut. )',
          '2 & 4+ ( gost pobeđuje i min. 4 gola na ut. )',
          '2 & 5+ ( gost pobeđuje i min. 5 golova na ut. )',
          '2 & 1P1+ ( gost pobeđuje i min. 1 gol u I pol. )',
          '2 & 1P2+ ( gost pobeđuje i min. 2 gola u I pol. )',
          '2 & 2P2+ ( gost pobeđuje i min. 2 gola u II pol. )',
          '2&1P1+ & 2P1+ ( gost pobeđuje i min. po 1 gol i u I pol. i u II pol. )',
          '2 & 0-2 ( gost pobeđuje i na ut. će biti od 0 do 2 gola )',
          '2 & 0-3 ( gost pobeđuje i na ut. će biti od 0 do 3 gola )',
          '2 & 0-4 ( gost pobeđuje i na ut. će biti od 0 do 4 gola )',
          '2 & 2-3 ( gost pobeđuje i na ut. će biti od 2 do 3 gola )',
          '2 & 2-4 ( gost pobeđuje i na ut. će biti od 2 do 4 gola )',
          '2 & 2-5 ( gost pobeđuje i na ut. će biti od 2 do 5 golova )',
          '2 & 2-6 ( gost pobeđuje i na ut. će biti od 2 do 6 golova )',
          '2 & 3-4 ( gost pobeđuje i na ut. će biti od 3 do 4 gola )',
          '2 & 3-5 ( gost pobeđuje i na ut. će biti od 3 do 5 golova )',
          '2 & 3-6 ( gost pobeđuje i na ut. će biti od 3 do 6 golova )',
          '2 & 2P2-3 ( gost pobeđuje i u II pol. od 2 do 3 gola )',
          'X & 1P2-3 ( gost pobeđuje i u I pol. od 2 do 3 gola )',
          'X & 2+ ( nerešeno i na ut. će biti min. 2 gola )',
          'X & 3+ ( nerešeno i na ut. će biti min. 3 gola )',
          'X & 0-2 ( nerešeno i na ut. će biti od 0 do 2 gola )',
          '1 & 1 > ( dom. pobeđuje i na ut. više golova u I pol. )',
          '1 & 1 = 2 ( dom. pobeuje i isti br. golova u I pol. i u II pol. )',
          '1 & 2 > ( dom. pobeđuje i na ut. više golova u II pol. )',
          '2 & 1 > ( gost. pobeđuje i na ut. više golova u I pol. )',
          '2 & 1 = 2 ( gost pobeuje i isti br. golova u I pol. i u II pol. )',
          '2 & 2 > ( gost pobeđuje i na ut. više golova u II pol. )',
        ],
      },
      {
        subtitle: 'Konačan ishod - GG',
        subKey: 'finalOutcomeGG',
        names: [
          '1 & GG ( dom. pobeđuje i oba tima daju gol na utakmici )',
          'X & GG ( nerešeno i oba tima daju gol na utakmici )',
          '2 & GG ( gost pobeđuje i oba tima daju gol na utakmici )',
        ],
      },
      {
        subtitle: 'Miks dupla šansa - golovi',
        subKey: 'mixDoubleChanceGoals',
        names: [
          '1X & 2+ ( dom. ne gubi i min. 2 gola na utakmici )',
          '1X & 3+ ( dom. ne gubi i min. 3 gola na utakmici )',
          '1X & 4+ ( dom. ne gubi i min. 4 gola na utakmici )',
          '1X & 0-2 ( dom. ne gubi i od 0 do 2 gola na utakmici )',
          '1X & 0-3 ( dom. ne gubi i od 0 do 3 gola na utakmici )',
          '1X & 2-3 ( dom. ne gubi i od 2 do 3 gola na utakmici )',
          '1X & 1P0-1 ( dom. ne gubi i od 0 do 1 gol u I pol. )',
          '1X & 1P2+ ( dom. ne gubi od 2+ golova u I pol. )',
          '1X & D2+ ( dom. ne gubi i daje min. 2 gola na utakmici )',
          '1X & 1-2 ( dom. ne gubi i od 1 do 2 gola na utakmici )',
          '1X & 1-3 ( dom. ne gubi i od 1 do 3 gola na utakmici )',
          '1X & 2-4 ( dom. ne gubi i od 2 do 4 gola na utakmici )',
          '1X & 2-5 ( dom. ne gubi i od 2 do 5 golova na utakmici )',
          '1X & 3-5 ( dom. ne gubi i od 3 do 5 golova na utakmici )',
          '1X & 3-6 ( dom. ne gubi i od 3 do 6 golova na utakmici )',
          '1X & 4-6 ( dom. ne gubi i od 4 do 6 golova na utakmici )',
          'X2 & 2+ ( gost ne gubi i min. 2 gola na utakmici )',
          'X2 & 4+ ( gost ne gubi i min. 4 gola na utakmici )',
          'X2 & 0-1 ( gost ne gubi i od 0 do 1 gola na utakmici )',
          'X2 & 0-2 ( gost ne gubi i od 0 do 2 gola na utakmici )',
          'X2 & 0-3 ( gost ne gubi i od 0 do 3 gola na utakmici )',
          'X2 & 2-3 ( gost ne gubi i od 2 do 3 gola na utakmici )',
          'X2 & 2-4 ( gost ne gubi i od 2 do 4 gola na utakmici )',
          'X2 & 1P0-1 ( gost ne gubi i od 0 do 1 gol u I pol. )',
          'X2 & 1P2+ ( gost ne gubi i min. 2 gola u I pol. )',
          'X2 & G2+ ( gost ne gubi i daje min. 2 gola na utakmici )',
          'X2 & 1-2 ( gost ne gubi i od 1 do 2 gola na ut. )',
          'X2 & 1-3 ( gost ne gubi i od 1 do 3 gola na ut. )',
          'X2 & 2-4 ( gost ne gubi i od 2 do 4 gola na ut. )',
          'X2 & 2-5 ( gost ne gubi i od 2 do 5 golova na ut. )',
          'X2 & 3-5 ( gost ne gubi i od 3 do 5 golova na ut. )',
          'X2 & 3-6 ( gost ne gubi i od 3 do 6 golova na ut. )',
          'X2 & 4-6 ( gost ne gubi i od 4 do 6 golova na ut. )',
          '12 & 2+ ( ne nerešeno i min. 2 gola na ut. )',
          '12 & 3+ ( ne nerešeno i min. 3 gola na ut. )',
          '12 & 0-2 ( ne nerešeno i od 0 do 2 gola na ut. )',
          '12 & 0-3 ( ne nerešeno i od 0 do 3 gola na ut. )',
          '12 & 2-3 ( ne nerešeno i od 2 do 3 gola na ut. )',
          '1X & GG ( dom. ne gubi i oba tima daju gol na ut. )',
          '12 & GG ( ne nerešeno i ob tima daju gol na ut. )',
          'X2 & GG ( gost ne gubi i oba tima daju gol na ut. )',
          '1X & 1 > ( dom. ne gubi i više golova u I pol. na ut. )',
          '1X & 1 = 2 ( dom. ne gubi i isti br. golova u I pol. i u II pol. )',
          '1X & 2 > ( dom. ne gubi i više golova u II pol. na ut. )',
          'X2 & 1 > ( gost ne gubi i više golova u I pol. na ut. )',
          'X2 & 1 = 2 ( gost ne gubi i isti br. golova u I pol. i u II pol. )',
          'X2 & 2 > ( gost ne gubi i više golova u II pol. na ut. )',
          '12 & 1 > ( ne nerešeno i više golova u I pol. na ut. )',
          '12 & 1 = 2 ( ne nerešeno i isti br. golova u I pol. i u II pol. )',
          '12 & 2 > ( ne nerešeno i više golova u II pol. na ut. )',
        ],
      },
      {
        subtitle: 'ili - ili',
        subKey: 'orOr',
        names: [
          '1 v 3+ ( ili pobeda dom. ili 3 i više golova na utakmici )',
          '1 v 4+ ( ili pobeda dom. ili 4 i više golova na utakmici )',
          '1 v GG ( ili pobeda dom. ili oba tima daju gol na ut. )',
          '2 v 3+ ( ili pobeda gosta ili 3 i više golova na utakmici )',
          '2 v 4+ ( ili pobeda gosta ili 4 i više golova na utakmici )',
          '2 v GG ( ili pobeda gosta ili oba tima daju gol na ut. )',
          'D4+ v G4+ ( i dom. i gost daju po min. 4 gola na ut. )',
          '1 v 1P2+ ( ili pobeda dom. ili 2i više golova u I pol. )',
          '2 v 2P2+ ( ili pobeda gosta ili 2i više golova u II pol. )',
          '1-1 v X-1 ( ili prelaz iz 1-1 ili prelaz iz X-1 )',
          '1-1 v X-X ( ili prelaz iz 1-1 ili prelaz iz X-X )',
          '1-1 v 2-2 ( ili prelaz iz 1-1 ili prelaz iz 2-2 )',
          '1P2+ v 2P2+ ( ili 2 i više golova u I pol. ili 2 i više u II pol. )',
          'GG1 v NG2 ( ili oba daju gol u I pol. ili min. jedan ne daje u II )',
          'NG1 v GG2 ( ili jedan ne daje gol u I pol. ili oba daju u II pol. )',
          'GG1 v GG2 ( ili oba daju gol u I pol. ilioba daju gol u II pol. )',
        ],
      },
      {
        subtitle: 'Miks I P - II P ( GG - NEGG )',
        subKey: 'mixGGandNEGG',
        names: [
          'P1 & GG1 ( pobeda dom. u I pol. i oba daju gol u I pol. )',
          'PX & GG1 ( nerešeno u I pol. i oba daju gol u I pol. )',
          'P2 & GG1 ( pobeda gosta u I pol. i oba daju gol u I pol. )',
          'P1 & NG1 ( pob. dom. u I pol. i min. 1 tim ne daje gol u I p. )',
          'PX & NG1 ( nerešeno u I pol. i min. 1 tim ne daje gol u I p. )',
          'P2 & NG1 ( pob. gosta u I pol. i min. 1 tim ne daje gol u I p. )',
          '2P1 & GG2 ( pob. dom. u Ii pol. i oba tima daju gol u II p. )',
          '2PX & GG2 ( nerešeno u II pol. i oba tima daju gol u I p. )',
          '2P2 & GG2 ( pob. dom. u I pol. i oba tima daju gol u II p. )',
          '2P1 & NG2 ( pob. dom. u Ii pol. i min 1 tim ne daje gol u II p. )',
          '2PX & NG2 ( nerešeno u II pol. i min 1 tim ne daje gol u II p. )',
          '2P2 & NG2 ( pob. dom. u I pol. i min 1 tim ne daje gol u II p. )',
          'GG1 & NG2 ( oba daju gol u I p. i min 1 tim ne daje gol u II p. )',
          'NG1 & NG2 ( min 1 tim ne daje gol ni u I p.ol. ni u II pol. )',
          'GG1 & GG2 ( oba tima daju gol i u I pol. i u II pol. )',
          'GG & 1P3+ ( oba daju gol na ut. i u I pol. pada min. 3 gola )',
          'GG & 2P3+ ( oba daju gol na ut. i u II pol. pada min. 3 gola )',
          'GG2 & 2P3+ ( oba daju gol u II pol.. i u II pol. pada min. 3 gola )',
          'GG2 & 1P3+ ( oba daju gol u II pol.. i u I pol. pada min. 3 gola )',
        ],
      },
      {
        subtitle: 'Miks poluvreme - golovi',
        subKey: 'mixHalftimeGoals',
        names: [
          '1-1 & GG ( prelaz PK 1-1 i oba daju gol na ut. )',
          '1-1 & NG ( prelaz PK 1-1 i min. 1 tim ne daje gol na ut. )',
          '1-1 & 2+ ( prelaz PK 1-1 i 2 ili više golova na ut. )',
          '1-1 & 3+ ( prelaz PK 1-1 i 3 ili više golova na ut. )',
          '1-1 & 4+ ( prelaz PK 1-1 i 4 ili više golova na ut. )',
          '1-1 & 1P2+ ( prelaz PK 1-1 i 2 ili više golova u I pol. )',
          '1-1 & 2P2+ ( prelaz PK 1-1 i 2 ili više golova u II pol. )',
          '1-1 & 0-2 ( prelaz PK 1-1 i od 0 do 2 gola na utakmici )',
          '1-1 & 0-3 ( prelaz PK 1-1 i od 0 do 3 gola na utakmici )',
          '1-1 & 2-3 ( prelaz PK 1-1 i od 2 do 3 gola na utakmici )',
          '1-1 & 2-4 ( prelaz PK 1-1 i od 2 do 4 gola na utakmici )',
          '1-1 & 2-5 ( prelaz PK 1-1 i od 2 do 5 golova na utakmici )',
          '1-1 & 3-4 ( prelaz PK 1-1 i od 3 do 4 gola na utakmici )',
          '1-1 & 3-5 ( prelaz PK 1-1 i od 3 do 5 golova na utakmici )',
          '1-1 & 3-6 ( prelaz PK 1-1 i od 3 do 6 golova na utakmici )',
          '1-1 & HP1 ( prelaz PK 1-1 i pobeda dom. od min 2 gola raz. )',
          '2-2 & GG ( prelaz PK 2-2 i oba daju gol na ut. )',
          '2-2 & NG ( prelaz PK 2-2 i min. 1 tim ne daje gol na ut. )',
          '2-2 & 2+ ( prelaz PK 2-2 i 2 ili više golova na ut. )',
          '2-2 & 3+ ( prelaz PK 2-2 i 3 ili više golova na ut. )',
          '2-2 & 4+ ( prelaz PK 2-2 i 4 ili više golova na ut. )',
          '2-2 & 1P2+ ( prelaz PK 2-2  i 2 ili više golova u I pol. )',
          '2-2 & 2P2+ ( prelaz PK 2-2 i 2 ili više golova u II pol. )',
          '2-2 & 0-2 ( prelaz PK 2-2 i od 0 do 2 gola na utakmici )',
          '2-2 & 0-3 ( prelaz PK 2-2 i od 0 do 3 gola na utakmici )',
          '2-2 & 2-3 ( prelaz PK 2-2 i od 2 do 3 gola na utakmici )',
          '2-2 & 2-4 ( prelaz PK 2-2 i od 2 do 4 gola na utakmici )',
          '2-2 & 2-5 ( prelaz PK 2-2 i od 2 do 5 golova na utakmici )',
          '2-2 & 3-4 ( prelaz PK 2-2 i od 3 do 4 gola na utakmici )',
          '2-2 & 3-5 ( prelaz PK 2-2 i od 3 do 5 golova na utakmici )',
          '2-2 & 3-6 ( prelaz PK 2-2 i od 3 do 6 golova na utakmici )',
          '2-2 & HP2 ( prelaz PK 2-2 i pobeda gosta od min 2 gola raz. )',
          'X-1 & GG ( prelaz PK X-1 i oba daju gol na ut. )',
          'X-1 & NG ( prelaz PK X-1 i min. 1 tim ne daje gol na ut. )',
          'X-1 & 2+ ( prelaz PK X-1 i 2 ili više golova na ut. )',
          'X-1 & 3+ ( prelaz PK X-1 i 3 ili više golova na ut. )',
          'X-1 & 4+ ( prelaz PK X-1 i 4 ili više golova na ut. )',
          'X-1 & 1P2+ ( prelaz PK X-1  i 2 ili više golova u I pol. )',
          'X-1 & 2P2+ ( prelaz PK X-1 i 2 ili više golova u II pol. )',
          'X-1 & 0-1 ( prelaz PK X-1 i od 0 do 1 gola na utakmici )',
          'X-1 & 0-2 ( prelaz PK X-1 i od 0 do 2 gola na utakmici )',
          'X-1 & 0-3 ( prelaz PK X-1 i od 0 do 3 gola na utakmici )',
          'X-1 & 2-3 ( prelaz PK X-1 i od 2 do 3 gola na utakmici )',
          'X-1 & 2-4 ( prelaz PK X-1 i od 2 do 4 gola na utakmici )',
          'X-1 & 2-5 ( prelaz PK X-1 i od 2 do 5 golova na utakmici )',
          'X-1 & 3-4 ( prelaz PK X-1 i od 3 do 4 gola na utakmici )',
          'X-1 & 3-5 ( prelaz PK X-1 i od 3 do 5 golova na utakmici )',
          'X-1 & 3-6 ( prelaz PK X-1 i od 3 do 6 golova na utakmici )',
          'X-1 & HP1 ( prelaz PK X-1 i pobeda gosta od min 2 gola raz. )',
          'X-2 & GG ( prelaz PK X-2 i oba daju gol na ut. )',
          'X-2 & NG ( prelaz PK X-2 i min. 1 tim ne daje gol na ut. )',
          'X-2 & 2+ ( prelaz PK X-2 i 2 ili više golova na ut. )',
          'X-2 & 3+ ( prelaz PK X-2 i 3 ili više golova na ut. )',
          'X-2 & 4+ ( prelaz PK X-2 i 4 ili više golova na ut. )',
          'X-2 & 1P2+ ( prelaz PK X-2  i 2 ili više golova u I pol. )',
          'X-2 & 2P2+ ( prelaz PK X-2 i 2 ili više golova u II pol. )',
          'X-2 & 0-1 ( prelaz PK X-2 i od 0 do 1 gola na utakmici )',
          'X-2 & 0-2 ( prelaz PK X-2 i od 0 do 2 gola na utakmici )',
          'X-2 & 0-3 ( prelaz PK X-2 i od 0 do 3 gola na utakmici )',
          'X-2 & 2-3 ( prelaz PK X-2 i od 2 do 3 gola na utakmici )',
          'X-2 & 2-4 ( prelaz PK X-2 i od 2 do 4 gola na utakmici )',
          'X-2 & 2-5 ( prelaz PK X-2 i od 2 do 5 golova na utakmici )',
          'X-2 & 3-4 ( prelaz PK X-2 i od 3 do 4 gola na utakmici )',
          'X-2 & 3-5 ( prelaz PK X-2 i od 3 do 5 golova na utakmici )',
          'X-2 & 3-6 ( prelaz PK X-2 i od 3 do 6 golova na utakmici )',
          'X-2 & HP2 ( prelaz PK X-2 i pobeda gosta od min 2 gola raz. )',
          'X-X & 2+ ( prelaz PK X-X i min. 2 gola na utakmici )',
          'X-X & 3+ ( prelaz PK X-X i min. 3 gola na utakmici )',
          'X-X & 0-2 ( prelaz PK X-X i od 0 do 2 gola na utakmici )',
          '1-2 & 5+ ( prelaz PK 1-2 i min. 5 golova na utakmici )',
          '2-1 & HP2 ( prelaz PK 2-1 i min. 5 golova na utakmici )',
        ],
      },
    ],
  },
  {
    title: 'Tačan rezultat',
    key: 'exactScore',
    sections: [
      {
        subtitle: 'Tačan rezultat',
        subKey: 'exactScore',
        names: [
          'TR 0:0 ( Tačan rezultat 0:0 )',
          'TR 1:0 ( Tačan rezultat 1:0 )',
          'TR 0:1 ( Tačan rezultat 0:1 )',
          'TR 1:1 ( Tačan rezultat 1:1 )',
          'TR 2:0 ( Tačan rezultat 2:0 )',
          'TR 0:2 ( Tačan rezultat 0:2 )',
          'TR 2:1 ( Tačan rezultat 2:1 )',
          'TR 1:2 ( Tačan rezultat 1:2 )',
          'TR 3:0 ( Tačan rezultat 3:0 )',
          'TR 0:3 ( Tačan rezultat 0:3 )',
          'TR 2:2 ( Tačan rezultat 2:2 )',
          'TR 4:0 ( Tačan rezultat 4:0 )',
          'TR 0:4 ( Tačan rezultat 0:4 )',
          'TR 3:1 ( Tačan rezultat 3:1 )',
          'TR 1:3 ( Tačan rezultat 1:3 )',
          'TR 3:2 ( Tačan rezultat 3:2 )',
          'TR 2:3 ( Tačan rezultat 2:3 )',
          'TR 4:1 ( Tačan rezultat 4:1 )',
          'TR 1:4 ( Tačan rezultat 1:4 )',
          'TR 5:0 ( Tačan rezultat 5:0 )',
          'TR 0:5 ( Tačan rezultat 0:5 )',
          'TR 3:3 ( Tačan rezultat 3:3 )',
          'TR 4:2 ( Tačan rezultat 4:2 )',
          'TR 2:4 ( Tačan rezultat 2:4 )',
          'TR 5:1 ( Tačan rezultat 5:1 )',
          'TR 1:5 ( Tačan rezultat 1:5 )',
          'OSTALO ( Tačan rezultat OSTALO )',
        ],
      },
      {
        subtitle: 'Tačan Rezultat - Prvo poluvreme',
        subKey: 'exactScoreFirstHalf',
        names: [
          'P 0:0 ( Tačan rezultat prvog poluvremena - 0:0 )',
          'P 1:0 ( Tačan rezultat prvog poluvremena - 1:0 )',
          'P 0:1 ( Tačan rezultat prvog poluvremena - 0:1 )',
          'P 1:1 ( Tačan rezultat prvog poluvremena - 1:1 )',
          'P 2:0 ( Tačan rezultat prvog poluvremena - 2:0 )',
          'P 0:2 ( Tačan rezultat prvog poluvremena - 0:2 )',
          'P 2:1 ( Tačan rezultat prvog poluvremena - 2:1 )',
          'P 1:2 ( Tačan rezultat prvog poluvremena - 1:2 )',
          'P 3:0 ( Tačan rezultat prvog poluvremena - 3:0 )',
          'P 0:3 ( Tačan rezultat prvog poluvremena - 0:3 )',
          'P 2:2 ( Tačan rezultat prvog poluvremena - 2:2 )',
          'P 3:1 ( Tačan rezultat prvog poluvremena - 3:1 )',
          'P 1:3 ( Tačan rezultat prvog poluvremena - 1:3 )',
          'P 3:2 ( Tačan rezultat prvog poluvremena - 3:2 )',
          'P 2:3 ( Tačan rezultat prvog poluvremena - 2:3 )',
          'P 3:3 ( Tačan rezultat prvog poluvremena - 3:3 )',
          'OSTALO ( Tačan rezultat prvog poluvremena - OSTALO )',
        ],
      },
    ],
  },
]

export const getInitialData = () => ({
  values: {
    odds: ['', '', ''], // KI1 (home win), KIX (draw), KI2 (away win)
    totalGoals: ['', ''], // UG 0-2, UG 3+
    bothTeams: ['', ''], // GG (yes), NEGG (no)
  },
  results: {
    goalsAndExactScores: {
      averageGoals: [
        '', // MIN
        '', // SRD
        '', // MAX
      ],
      averageExactScore: [
        '', // MIN
        '', // SRD
        '', // MAX
      ],
      averageExactScoreDecimal: [
        '', // MIN
        '', // SRD
        '', // MAX
      ],
    },
    finalOutcome: {
      finalOutcome: [
        '', // KI 1
        '', // KI X
        '', // KI 2
      ],
      doubleChance: [
        '', // KI 1X
        '', // KI 12
        '', // KI X2
      ],
      doubleWin: [
        '', // DP 1
        '', // DP 2
        '', // SPD 1
        '', // SPD 2
      ],
      halftimeFulltime: [
        '', // PP 1 ILI KI 1
        '', // PP X ILI KI X
        '', // PP 2 ILI KI 2
      ],
      winByMargin: [
        '', // DW 1
        '', // DW 2
        '', // DW 3+
        '', // GW 1
        '', // GW 2
        '', // GW 3+
      ],
      firstHalf: [
        '', // PP 1
        '', // PP X
        '', // PP 2
      ],
      doubleChanceFirstHalf: [
        '', // PP 1X
        '', // PP 12
        '', // PP X2
      ],
      superWin: [
        '', // SP 1
        '', // SP 2
      ],
      secondHalf: [
        '', // DP 1
        '', // DP X
        '', // DP 2
      ],
      doubleChanceSecondHalf: [
        '', // DP 1X
        '', // DP 12
        '', // DP X2
      ],
      winner: [
        '', // W 1
        '', // W 2
      ],
      winnerFirstHalf: [
        '', // WP 1
        '', // WP 2
      ],
      winnerSecondHalf: [
        '', // WDP 1
        '', // WDP 2
      ],
    },
    totalGoals: {
      goalRangeOf1: [
        '', // UG 0-1
        '', // UG 1-2
        '', // UG 2-3
        '', // UG 3-4
        '', // UG 4-5
        '', // UG 5-6
      ],
      goalRangeOf2: [
        '', // UG 0-2
        '', // UG 1-3
        '', // UG 2-4
        '', // UG 3-5
        '', // UG 4-6
      ],
      goalRangeOf3: [
        '', // UG 0-3
        '', // UG 1-4
        '', // UG 2-5
        '', // UG 3-6
      ],
      goalRangeOf4: [
        '', // UG 0-4
        '', // UG 1-5
        '', // UG 2-6
      ],
      goalPlus: [
        '', // UG 2+
        '', // UG 3+
        '', // UG 4+
        '', // UG 5+
        '', // UG 6+
        '', // UG 7+
      ],
      exactScore: [
        '', // T 0
        '', // T 1
        '', // T 2
        '', // T 3
        '', // T 4
        '', // T 5
        '', // T 6
      ],
      bothTeamsScore: [
        '', // GG
        '', // NEGG
        '', // GG 1
        '', // NEGG 1
        '', // GG 2
        '', // NEGG 2
      ],
      firstGoal: [
        '', // PG 1
        '', // PG X
        '', // PG 2
        '', // PP PG
        '', // DP PG
        '', // PP PGD
        '', // PP PGG
        '', // DP PGD
        '', // DP PGD
      ],
      lastGoal: [
        '', // ZG 1
        '', // ZG 2
      ],
      totalGoalsFirstHalf: [
        '', // PP 1+
        '', // PP 2+
        '', // PP 3+
        '', // PP 4+
        '', // PP 0-1
        '', // PP 0-2
        '', // PP 1-2
        '', // PP 1-3
        '', // PP 2-3
        '', // PT 0
        '', // PT 1
        '', // PT 2
        '', // PT 3
        '', // PP NEG 1
        '', // PP NEG 2
        '', // PPGX
      ],
      totalGoalsSecondHalf: [
        '', // DP 1+
        '', // DP 2+
        '', // DP 3+
        '', // DP 4+
        '', // DP 0-1
        '', // DP 0-2
        '', // DP 1-2
        '', // DP 1-3
        '', // DP 2-3
        '', // DPT 0
        '', // DPT 1
        '', // DPT 2
        '', // DPT 3
        '', // DP NEG 1
        '', // DP NEG 2
        '', // DPGX
      ],
      goalSpreadOf1: [
        '', // 1P1+ & 2+
        '', // 1P1+ & 3+
        '', // 1P1+ & 2P1+
        '', // 1P1+ & 2P2+
        '', // 1P1+ & 2P3+
        '', // 1P1+ & 2P0-1
        '', // 1P1+ & 2P0-2
        '', // 1P1+ & 2P1-2
        '', // 1P1+ & 2P1-3
        '', // 1P1+ & 2P2-3
        '', // 1P0-1 & 2P2+
        '', // 1P0-1 & 2P0-1
        '', // 1P0-1 & 2P0-3
        '', // 1P0-1 & 2P1-2
        '', // 1P0-1 & 2P1-3
        '', // 1P0-1 & 2P2-3
        '', // 1P2+ & 2P1+
        '', // 1P2+ & 2P2+
        '', // 1P2+ & 2P3+
        '', // 1P2+ & 2P4+
        '', // 1P2+ & 2P0-1
        '', // 1P2+ & 2P2-3
        '', // 1P0-2 & 2P2+
        '', // 1P0-2 & 2P0-1
        '', // 1P0-2 & 2P0-2
        '', // 1P0-2 & 2P0-3
        '', // 1P0-2 & 2P1-2
        '', // 1P0-2 & 2P1-3
        '', // 1P0-2 & 2P2-3
        '', // 1P1-2 & 2P1+
        '', // 1P1-2 & 2P2+
        '', // 1P1-2 & 2P0-1
        '', // 1P1-2 & 2P0-2
        '', // 1P1-2 & 2P0-3
        '', // 1P1-2 & 2P3+
        '', // 1P1-2 & 2P4+
        '', // 1P1-3 & 2P3+
        '', // 1P1-3 & 2P1+
        '', // 1P1-3 & 2P2+
        '', // 1P1-3 & 2P1-2
        '', // 1P1-3 & 2P1-3 gola
        '', // 1P2-3 & 2P1+
        '', // 1P2-3 & 2P2+
        '', // 1P2-3 & 2P3+
        '', // 1P2-3 & 2P4+
        '', // 1P2-3 & 2P0-1
        '', // 1P2-3 & 2P0-2
        '', // 1P2-3 & 2P1-3
        '', // 1P2-3 & 2P1-2
        '', // 1P2-3 & 2P2-3
        '', // 1P2+&4+
        '', // 2P2+&4+
      ],
      homeGoals: [
        '', // D1+
        '', // D2+
        '', // D3+
        '', // D4+
        '', // D 0-1
        '', // D 0-2
        '', // D 0-3
        '', // D 0
        '', // DT 1
        '', // DT 2
        '', // DT 3
        '', // D 1-2
        '', // D 1-3
        '', // D 2-3
        '', // D 2-4
        '', // D 2-5
        '', // D 2-6
        '', // D 3-4
        '', // D 3-5
        '', // D 4-6
        '', // DT 4
        '', // DT 5
        '', // DT 6
        '', // D UG 7+
      ],
      homeGoalsFirstHalf: [
        '', // 1D1+
        '', // 1D2+
        '', // 1D3+
        '', // 1D4+
        '', // 1D 0
        '', // 1DT 1
        '', // 1DT 2
        '', // 1D 0-1
        '', // 1D 1-2
        '', // 1D 2-3
        '', // 1PPG1
        '', // 1DT 3
      ],
      homeGoalsSecondHalf: [
        '', // 2D1+
        '', // 2D2+
        '', // 2D3+
        '', // 2D4+
        '', // 2D 0
        '', // 2DT 1
        '', // 2DT 2
        '', // 2D 0-1
        '', // 2D 1-2
        '', // 2D 2-3
        '', // 2PPG1
        '', // 2DT 3
      ],
      homeGoalsHomeMix: [
        '', // 1D1+ & D2+
        '', // 1D1+ & D3+
        '', // 1D1+ & 2D2+
        '', // 1D2+ & 2D1+
        '', // 1D2+ & 2D2+
        '', // 1D0-1 & 2D0-1
        '', // 1D0-1 & 2D0-2
        '', // 1D0-2 & 2D0-1
        '', // 1D0-2 & 2D0-2
        '', // 1D1 & 4+
      ],
      guestGoals: [
        '', // G1+
        '', // G2+
        '', // G3+
        '', // G4+
        '', // G 0-1
        '', // G 0-2
        '', // G 0-3
        '', // G 0
        '', // GT 1
        '', // GT 2
        '', // GT 3
        '', // G 1-2
        '', // G 1-3
        '', // G 2-3
        '', // G 2-4
        '', // G 2-5
        '', // G 2-6
        '', // G 3-4
        '', // G 3-5
        '', // G 4-6
        '', // GT 4
        '', // GT 5
        '', // GT 6
        '', // G UG 7+
      ],
      guestGoalsFirstHalf: [
        '', // 1G1+
        '', // 1G2+
        '', // 1G3+
        '', // 1G4+
        '', // 1G 0
        '', // 1GT 1
        '', // 1GT 2
        '', // 1G 0-1
        '', // 1G 1-2
        '', // 1G 2-3
        '', // 1PPG 2
        '', // 1GT 3
      ],
      guestGoalsSecondHalf: [
        '', // 2G1+
        '', // 2G2+
        '', // 2G3+
        '', // 2G4+
        '', // 2G 0
        '', // 2GT 1
        '', // 2GT 2
        '', // 2G 0-1
        '', // 2G 1-2
        '', // 2G 2-3
        '', // 2PPG 2
        '', // 2GT 3
      ],
      homeGoalsMix: [
        '', // 1G1+ & G2+
        '', // 1G1+ & G3+
        '', // 1G1+ & 2G2+
        '', // 1G2+ & 2G1+
        '', // 1G2+ & 2G2+
        '', // 1G0-1 & 2G0-1
        '', // 1G0-1 & 2G0-2
        '', // 1G0-2 & 2G0-1
        '', // 1G0-2 & 2G0-2
        '', // 1G1 & 2G4+
      ],
      mixGG: [
        '', // GG3+
        '', // GG4+
        '', // D2+ & G2+
        '', // GG & D2+
        '', // GG & G2+
        '', // GG & 2-3
        '', // NEGG3+
      ],
      scoreOrNoScoreHome: [
        '', // DGD
        '', // NGD
      ],
      scoreOrNoScoreAway: [
        '', // DGG
        '', // NGG
      ],
      moreGoalsIn: [
        '', // 1 >
        '', // 1 = 2
        '', // 2 >
      ],
    },
    halftimeEnd: {
      halftimeEnd: [
        '', // PK 1-1
        '', // PK 1-X
        '', // PK 1-2
        '', // PK X-1
        '', // PK X-X
        '', // PK X-2
        '', // PK 2-1
        '', // PK 2-X
        '', // PK 2-2
        '', // NE 1-1
        '', // NE 2-2
        '', // PK X-1
        '', // PK X-X
        '', // PK X-2
        '', // NE 1-2
        '', // NE 1-X
        '', // NE 2-1
        '', // NE 2-X
      ],
      halftimeEndDoubleChance: [
        '', // PK 1-1X
        '', // PK 1-X2
        '', // PK 1-12
        '', // PK 2-1X
        '', // PK 2-X2
        '', // PK 2-12
        '', // PK X-1X
        '', // PK X-X2
        '', // PK X-12
        '', // PK 1X-1
        '', // PK 1X-X
        '', // PK 1X-2
        '', // PK X2-1
        '', // PK X2-X
        '', // PK X2-2
        '', // PK 12-1
        '', // PK 12-X
        '', // PK 12-2
        '', // PK 1X-1X
        '', // PK 1X-X2
        '', // PK 1X-12
        '', // PK X2-1X
        '', // PK X2-X2
        '', // PK X2-12
        '', // PK 12-1X
        '', // PK 12-X2
        '', // PK 12-12
      ],
    },
    handicaps: {
      handicapMinus1: [
        '', // H 1
        '', // H X
        '', // H 2
      ],
      handicapMinus2: [
        '', // H 1
        '', // H X
        '', // H 2
      ],
    },
    mixGames: {
      finalOutcomeGoals: [
        '', // 1 & D2+
        '', // 1 & D3+
        '', // 1 & 3+
        '', // 1 & 4+
        '', // 1 & 5+
        '', // 1 & 1P1+
        '', // 1 & 1P2+
        '', // 1 & 2P1+
        '', // 1 & 2P2+
        '', // 1&1P1+ & 2P1+
        '', // 1 & 0-2
        '', // 1 & 0-3
        '', // 1 & 0-4
        '', // 1 & 2-3
        '', // 1 & 2-4
        '', // 1 & 2-5
        '', // 1 & 2-6
        '', // 1 & 3-4
        '', // 1 & 3-5
        '', // 1 & 3-6
        '', // 1 & 1P2-3
        '', // 2 & G2+
        '', // 2 & G3+
        '', // 2 & 3+
        '', // 2 & 4+
        '', // 2 & 5+
        '', // 2 & 1P1+
        '', // 2 & 1P2+
        '', // 2 & 2P2+
        '', // 2&1P1+ & 2P1+
        '', // 2 & 0-2
        '', // 2 & 0-3
        '', // 2 & 0-4
        '', // 2 & 2-3
        '', // 2 & 2-4
        '', // 2 & 2-5
        '', // 2 & 2-6
        '', // 2 & 3-4
        '', // 2 & 3-5
        '', // 2 & 3-6
        '', // 2 & 2P2-3
        '', // X & 1P2-3
        '', // X & 2+
        '', // X & 3+
        '', // X & 0-2
        '', // 1 & 1 >
        '', // 1 & 1 = 2
        '', // 1 & 2 >
        '', // 2 & 1 >
        '', // 2 & 1 = 2
        '', // 2 & 2 >
      ],
      finalOutcomeGG: [
        '', // 1 & GG
        '', // X & GG
        '', // 2 & GG
      ],
      mixDoubleChanceGoals: [
        '', // 1X & 2+
        '', // 1X & 3+
        '', // 1X & 4+
        '', // 1X & 0-2
        '', // 1X & 0-3
        '', // 1X & 2-3
        '', // 1X & 1P0-1
        '', // 1X & 1P2+
        '', // 1X & D2+
        '', // 1X & 1-2
        '', // 1X & 1-3
        '', // 1X & 2-4
        '', // 1X & 2-5
        '', // 1X & 3-5
        '', // 1X & 3-6
        '', // 1X & 4-6
        '', // X2 & 2+
        '', // X2 & 4+
        '', // X2 & 0-1
        '', // X2 & 0-2
        '', // X2 & 0-3
        '', // X2 & 2-3
        '', // X2 & 2-4
        '', // X2 & 1P0-1
        '', // X2 & 1P2+
        '', // X2 & G2+
        '', // X2 & 1-2
        '', // X2 & 1-3
        '', // X2 & 2-4
        '', // X2 & 2-5
        '', // X2 & 3-5
        '', // X2 & 3-6
        '', // X2 & 4-6
        '', // 12 & 2+
        '', // 12 & 3+
        '', // 12 & 0-2
        '', // 12 & 0-3
        '', // 12 & 2-3
        '', // 1X & GG
        '', // 12 & GG
        '', // X2 & GG
        '', // 1X & 1 >
        '', // 1X & 1 = 2
        '', // 1X & 2 >
        '', // X2 & 1 >
        '', // X2 & 1 = 2
        '', // X2 & 2 >
        '', // 12 & 1 >
        '', // 12 & 1 = 2
        '', // 12 & 2 >
      ],
      orOr: [
        '', // 1 v 3+
        '', // 1 v 4+
        '', // 1 v GG
        '', // 2 v 3+
        '', // 2 v 4+
        '', // 2 v GG
        '', // D4+ v G4+
        '', // 1 v 1P2+
        '', // 2 v 2P2+
        '', // 1-1 v X-1
        '', // 1-1 v X-X
        '', // 1-1 v 2-2
        '', // 1P2+ v 2P2+
        '', // GG1 v NG2
        '', // NG1 v GG2
        '', // GG1 v GG2
      ],
      mixGGandNEGG: [
        '', // P1 & GG1
        '', // PX & GG1
        '', // P2 & GG1
        '', // P1 & NG1
        '', // PX & NG1
        '', // P2 & NG1
        '', // 2P1 & GG2
        '', // 2PX & GG2
        '', // 2P2 & GG2
        '', // 2P1 & NG2
        '', // 2PX & NG2
        '', // 2P2 & NG2
        '', // GG1 & NG2
        '', // NG1 & NG2
        '', // GG1 & GG2
        '', // GG & 1P3+
        '', // GG & 2P3+
        '', // GG2 & 2P3+
        '', // GG2 & 1P3+
      ],
      mixHalftimeGoals: [
        '', // 1-1 & GG
        '', // 1-1 & NG
        '', // 1-1 & 2+
        '', // 1-1 & 3+
        '', // 1-1 & 4+
        '', // 1-1 & 1P2+
        '', // 1-1 & 2P2+
        '', // 1-1 & 0-2
        '', // 1-1 & 0-3
        '', // 1-1 & 2-3
        '', // 1-1 & 2-4
        '', // 1-1 & 2-5
        '', // 1-1 & 3-4
        '', // 1-1 & 3-5
        '', // 1-1 & 3-6
        '', // 1-1 & HP1
        '', // 2-2 & GG
        '', // 2-2 & NG
        '', // 2-2 & 2+
        '', // 2-2 & 3+
        '', // 2-2 & 4+
        '', // 2-2 & 1P2+
        '', // 2-2 & 2P2+
        '', // 2-2 & 0-2
        '', // 2-2 & 0-3
        '', // 2-2 & 2-3
        '', // 2-2 & 2-4
        '', // 2-2 & 2-5
        '', // 2-2 & 3-4
        '', // 2-2 & 3-5
        '', // 2-2 & 3-6
        '', // 2-2 & HP2
        '', // X-1 & GG
        '', // X-1 & NG
        '', // X-1 & 2+
        '', // X-1 & 3+
        '', // X-1 & 4+
        '', // X-1 & 1P2+
        '', // X-1 & 2P2+
        '', // X-1 & 0-1
        '', // X-1 & 0-2
        '', // X-1 & 0-3
        '', // X-1 & 2-3
        '', // X-1 & 2-4
        '', // X-1 & 2-5
        '', // X-1 & 3-4
        '', // X-1 & 3-5
        '', // X-1 & 3-6
        '', // X-1 & HP1
        '', // X-2 & GG
        '', // X-2 & NG
        '', // X-2 & 2+
        '', // X-2 & 3+
        '', // X-2 & 4+
        '', // X-2 & 1P2+
        '', // X-2 & 2P2+
        '', // X-2 & 0-1
        '', // X-2 & 0-2
        '', // X-2 & 0-3
        '', // X-2 & 2-3
        '', // X-2 & 2-4
        '', // X-2 & 2-5
        '', // X-2 & 3-4
        '', // X-2 & 3-5
        '', // X-2 & 3-6
        '', // X-2 & HP2
        '', // X-X & 2+
        '', // X-X & 3+
        '', // X-X & 0-2
        '', // 1-2 & 5+
        '', // 2-1 & HP2
      ],
    },
    exactScore: {
      exactScore: [
        '', // TR 0:0
        '', // TR 1:0
        '', // TR 0:1
        '', // TR 1:1
        '', // TR 2:0
        '', // TR 0:2
        '', // TR 2:1
        '', // TR 1:2
        '', // TR 3:0
        '', // TR 0:3
        '', // TR 2:2
        '', // TR 4:0
        '', // TR 0:4
        '', // TR 3:1
        '', // TR 1:3
        '', // TR 3:2
        '', // TR 2:3
        '', // TR 4:1
        '', // TR 1:4
        '', // TR 5:0
        '', // TR 0:5
        '', // TR 3:3
        '', // TR 4:2
        '', // TR 2:4
        '', // TR 5:1
        '', // TR 1:5
        '', // OSTALO
      ],
      exactScoreFirstHalf: [
        '', // P 0:0
        '', // P 1:0
        '', // P 0:1
        '', // P 1:1
        '', // P 2:0
        '', // P 0:2
        '', // P 2:1
        '', // P 1:2
        '', // P 3:0
        '', // P 0:3
        '', // P 2:2
        '', // P 3:1
        '', // P 1:3
        '', // P 3:2
        '', // P 2:3
        '', // P 3:3
        '', // OSTALO
      ],
    },
  },
})
